import { createReducer } from '@reduxjs/toolkit'

import { CreateReducer } from 'redux/utils'

import { changeLimit, changePage } from './pagination.actions'

import type { PaginationState } from '.'

export const paginateDefaultState: PaginationState = {
  page: 1,
  limit: 10,
  limitOptions: [10, 25, 50],
}

export const paginationReducer: CreateReducer<PaginationState> = (sliceName, initialState) =>
  createReducer(
    {
      ...paginateDefaultState,
      ...initialState,
    },
    builder => {
      builder
        .addCase(changePage(sliceName), (state, { payload }) => {
          state.page = payload
        })
        .addCase(changeLimit(sliceName), (state, { payload }) => {
          state.page = 1
          state.limit = payload
        })
    },
  )
